export const ADMIN_PANELS = {
  brandingPage: 'Personalisation Settings',
  dashboardsPage: 'Dashboards Visuals',
  kpisPage: 'KPI Launchpad',
  infoBoxesPage: 'Info Bar Configuration',
  customVisualsPage: 'Custom Visuals Settings',
  subjectAreaFiltersPage: 'Subject Area Filters',
  layoutFiltersPage: 'Dashboard Filters',
};

export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_AUTHOR = 'ROLE_AUTHOR';
